// extracted by mini-css-extract-plugin
export default {"legend":"Legend_legend__EAhhm"};